/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

export const ourValuesAccordions = [
  {
    id: "01",
    title: "Unsere Mandantschaft im Mittelpunkt",
    description:
      "Sie sind jederzeit unser Fokus! Wir wollen mehr sein als nur ein Dienstleister: Wir begleiten Sie verlässlich, verstehen Ihre Situation und lösen Ihr Anliegen klar und nachvollziehbar – oft schneller und einfacher, als Sie erwarten.",
  },
  {
    id: "02",
    title: "Expertise, die täglich wächst",
    description:
      "Unsere Erfahrung basiert auf über hunderttausend Fällen. Gleichzeitig lernen wir mit jedem neuen Fall dazu und entwickeln unser Wissen kontinuierlich weiter – strukturiert, datenbasiert und mit echter Neugier.",
  },
  {
    id: "03",
    title: "Veränderung und Technologie als Chance",
    description:
      "Recht und Technologie entwickeln sich ständig weiter. Wir behalten alles im Blick und entwickeln innovative Lösungen, durch die auch Sie immer einen Schritt voraus sind.",
  },
  {
    id: "04",
    title: "Vertrauen durch Transparenz",
    description:
      "Wir sprechen nicht in komplizierten juristischen Phrasen mit Ihnen, sondern nehmen uns immer Zeit für Erklärungen. In der Servicewelt haben Sie jederzeit Einblick in Ihren Fall und unsere Arbeit.",
  },
  {
    id: "05",
    title: "Teamwork und Zusammenhalt",
    description:
      "Wir arbeiten eng zusammen, unterstützen uns gegenseitig und übernehmen Verantwortung. So erreichen wir auch in komplexen Situationen gemeinsam die besten Ergebnisse.",
  },
];
